<template>
  <div v-if="body_show" class="bodys pj0">

    <div v-for="(k, index) in newData" :key="index + '/' + index">
      <!-- text -->
      <div v-if="k.type === 'text'" class="task_f">
        <h3 class="label">{{k.label}}</h3>
        <div class="input-box input-mt">
          <input v-model="k.config" type="text" />
        </div>
      </div>
      <!-- textarea -->
      <div v-if="k.type === 'textarea'" class="task_f">
        <h3 class="label">{{k.label}}</h3>
        <div class="input-mt">
          <textarea v-model="k.config"></textarea>
        </div>
      </div>
      <!-- introducer -->
      <div v-if="k.type === 'introducer'">
        <h2>{{k.label}}</h2>
      </div>
      <!-- title -->
      <div v-if="k.type === 'title'" class="p0-card">
        <div class="h2">{{k.label}}</div>
      </div>
      <!-- showtext -->
      <div v-if="k.type === 'showtext'" class="p0-card">
        <p v-for="item2 in k.config.text">{{item2}}</p>
      </div>

    </div>
    <div class="footer-box text-center">
      <van-button @click="addFromData" round size="normal" class="btn-yellow" type="default">提交</van-button>
      <van-button @click="showProView" round size="normal" :class="[imgurl.length ? '' : 'prohibit', 'btn-yellow']" type="default">转为图片</van-button>
    </div>
    <!-- 海报 -->
    <van-popup :lock-scroll="false" class="modul-box" v-model="showModul">
      <div class="modul">
        <img :src="imgurl" alt="" />
        <h3>长按图片保存</h3>
      </div>
    </van-popup>
    <!--  -->
    <div class="sign_up" v-if="data.project_type==1" @click="signHandle">立即报名</div>
     <!-- 验证手机号和付款 -->
    <public-mobile ref="handle" :cid="cid" :source="source" :type="'course'" :pdk="pdk" :aspx="aspx"></public-mobile>
  </div>
</template>
<script>
import { coursedetail, index, subtable } from "@/api/course";
import { shareCon } from "@/utils/wxconfig";
import { getStorage, setStorage } from "@/utils/tools"
export default {
  data() {
      return {
        body_show: false,
        data: {},
        phone: null,
        source: '',
        pdk: '',
        aspx: '',
        //
        newData: [],
        form_id: "",
        table_id: null,
        imgurl: "",
        showModul: false
      }
    },
    methods: {
      // 报告
      showProView(){
        if(this.imgurl){
          this.showModul = true;
        }
      },
      // table添加数据
      addRowData(){
        let key = this.table_id;
        let len = this.newData[key].thead.length;
        let createArr = this.createArrEle(len);
        this.newData[key].tbody.push(createArr);
      },
      pullData() {
        this.cid = this.$route.query.cid;
        this.pdk = this.$route.query.pdk;
        this.aspx = this.$route.query.aspx;
        let q = this.$route.query;
        //
        this.newData = [];
        // 接口2
        index({
            cid: q.cid,
            cpid: q.pid,
            cptid: q.id
          })
          .then((data) => {
            if(data.code===10002){
                this.$toast(data.data.msg);
                return
            }
            let userTable = data.userfield;
            let dataTable = data.field;
            //
            this.imgurl = data.imgurl;
            // from_id
            this.form_id = dataTable[0].form_id;
            // 重置

            for(let arg of dataTable){
              this.newData.push({
                "label": arg.label,
                "type": arg.type,
                "config": arg.config,
                "field_id": arg.id
              })
            }

            // 替换
            for(let item of userTable){
              for(let arg of this.newData){
                if(item.field_id == arg.field_id){
                  arg.config = item.content;
                }
              }
            }

            this.body_show = true;
          })
      },
      testDataTrim(){
        for(let arg of this.newData){
          if(arg.type == 'introducer' || arg.type == 'title' || arg.type == 'showtext'){
            continue;
          }
          if(!arg.config){
            return
          }
        }
        return true
      },
      // 提交数据
      addFromData(){
        let isAdopt = this.testDataTrim();
        if(!isAdopt){
          return
        }
        let q = this.$route.query;
        let fieldResult = this.machiningData();
        // 更改
        subtable({
          "cid": q.cid,
          "form_id": this.form_id,
          "field": fieldResult
        })
        .then((data) => {
          if(data.code){
            this.$toast.fail('添加失败');
          }else{
            this.$toast.success('添加成功');
            // 啦下新数据
            this.pullData();
          }
        })

      },
      // 加工数据
      machiningData(){
        let arrData = [];
        for(let arg of this.newData){
          if(arg.type == 'introducer' || arg.type == 'title' || arg.type == 'showtext'){
            continue;
          }
          //
          arrData.push({
            "field_id": arg['field_id'],
            "content": arg['config']
          })
        }
        // console.log(arrData);
        return JSON.stringify(arrData);
      },
      // 生成数组
      createArrEle(len){
        let arr = [];
        for(var i=0; i<len; i++){
          arr.push("");
        }
        return arr
      },
      setTitle(){
        document.title = this.$route.query.name;
      },
      // 立即报名
      signHandle() {
        // 神策统计--点击立即报名按钮
        let godPolicy = getStorage('godPolicy', 'godPolicy');
        let bool =true;
        if(!godPolicy || godPolicy.length ==0){
          bool = false;
          coursedetail({ // 因为目前只有一个，当前页面也没有bid所以暂时写死
            bid: 1
          })
          .then((data) => {
            godPolicy = data;
            // 把神策数据存到本地缓存
            let go = {
              course_id: this.cid,
              classification: data.bigcoursename,
              course_name: data.coursename,
              course_discount_price: data.courseprice,
              course_original_price: data.originalprice,
              course_starttime: data.begintime
            };
            setStorage('godPolicy', 'godPolicy', go);
            this.godPolicyHandle(false,godPolicy);
          })
        }else{
          this.godPolicyHandle(true,godPolicy);
        }
        if (this.data.mobilestatus) {
          // 是否需要验证验证码
          this.$refs.handle.need_verify = this.data.need_verify || false;
          // 判断用户手机号是否已验证
          this.$refs.handle.phone = this.data.userdetail.mobile ? this.data.userdetail.mobile : null;
          this.$refs.handle.show = true;

        } else {
          this.$refs.handle.pay()
        }
      },
      // 立即报名神策方法
      godPolicyHandle(bool,godPolicy){
        // 判断缓存是否有数据，如果没有请求数据
        sensors.track('applyCourse', {
          apply_page_url: location.href,
          apply_page_title: '个人战略—商业价值重塑课-项目导入p0',
          classification: bool?godPolicy.classification:godPolicy.bigcoursename,
          classification_id: 1,//bid
          course_id:this.$route.query.cid,
          course_name: bool?godPolicy.course_name:godPolicy.coursename,
          course_discount_price: bool?godPolicy.course_discount_price:godPolicy.courseprice,
          course_original_price: bool?godPolicy.course_original_price:godPolicy.originalprice,
          course_starttime: bool?godPolicy.course_starttime:godPolicy.begintime
        });
      },
    },
    created() {
      this.pullData();
      this.setTitle();
      shareCon("course",this);
    }
}
</script>
<style lang="scss" scoped>
  @import "@s/remChange.scss";
  @import "@s/taskStyle.scss";
  .bodys {
    padding-bottom: changeRem(1.96)+px
  }
  .pj0 {
    padding: changeRem(0.6)+px;
    h2 {
      margin: 0 changeRem(0.5)+px 0;
      font-size: changeRem(0.64)+px;
      color: #EB5032;
      line-height: changeRem(0.84)+px;
    }
    .p0-card {
      margin-top: changeRem(0.8)+px;
      padding-bottom: changeRem(0.24)+px;
      .h2 {
        color: #333333;
        font-size: changeRem(0.64)+px;
        height: changeRem(1.24)+px;
        background: #EBEBEB;
        border-left: changeRem(0.16)+px solid #EB5032;
        padding-left: changeRem(0.4)+px;
        text-align: left;
        line-height: changeRem(1.24)+px;
        font-weight: bold;
      }
      p {
        font-size: changeRem(0.56)+px;
        color: #333333;
        margin-top: changeRem(0.6)+px;
        line-height: changeRem(0.84)+px;
        text-align: justify;
      }
    }
  }
  .sign_up {
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 999;
    line-height: changeRem(1.96)+px;
    background-color: #EB5032;
    color: #FFFFFF;
    font-size: changeRem(.68)+px;
    text-align: center;
  }
  .footer-box{
    margin-top: 20px;
    .btn-yellow{
      background: #EB5032;
      color: #fff;
      margin: 0 10px;
      height: 60px;
      line-height: 60px;
      padding: 0 40px;
    }
    .prohibit{
      background: #cccccc;
    }
  }
  .table-box{
    margin-top: 20px;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    overflow-scrolling: touch;
    background: #fff;
    padding-bottom: 1px;
    padding-right: 1px;
    table{
      border-collapse:collapse;
    }
    td{
      border: 1px solid #EB5032;
      text-align: center;
      padding: 10px 0;
      overflow: hidden;
      width: 160px;
    }
    tbody{
      td{
        padding: 0;
      }
    }
    .textarea{
      &:after{
        border-color: #fff;
      }
    }
  }
  .add_btn{
    margin-top: 20px;
    border: 1px solid #EB5032;
    height: 60px;
    line-height: 60px;
    text-align: center;
    background: #EB5032;
    border-radius: 30px;
    color: #fff;
  }
  .modul-box{
    background: rgba(255,255,255,0);
  }
  .modul{
    overflow: auto;
    max-height: 100%;
    -webkit-overflow-scrolling: touch;
    overflow-scrolling: touch;
    h3{
      text-align: center;
      color: #fff;
      line-height: 80px;
    }
    img{
      max-width: 8rem;
    }
  }
</style>
<style>
  .textarea textarea{
    font-size: 30px;
  }
</style>
